import {
  FolderSearch,
  Inbox,
  Layers,
  Send,
  User,
  type LucideIcon,
} from 'lucide-react';
import { normalizeSearchFolderKind, type SearchFolderKind } from './useData';

export const FOLDER_KIND_LABELS: Record<SearchFolderKind, string> = {
  search: 'Rule search',
  inbox: 'Inbox',
  combined: 'Combined inbox',
  sent: 'Sent',
  combinedSent: 'Combined sent',
  mySent: 'My sent',
  combinedMySent: 'Combined my sent',
};

export const FOLDER_KIND_ICONS: Record<SearchFolderKind, LucideIcon> = {
  search: FolderSearch,
  inbox: Inbox,
  combined: Layers,
  sent: Send,
  combinedSent: Layers,
  mySent: User,
  combinedMySent: Layers,
};

export function folderKindBadgeClass(kind: SearchFolderKind): string {
  switch (kind) {
    case 'inbox':
      return 'border-sky-500/30 bg-sky-500/10 text-sky-700 dark:text-sky-300';
    case 'combined':
      return 'border-violet-500/30 bg-violet-500/10 text-violet-700 dark:text-violet-300';
    case 'sent':
      return 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300';
    case 'combinedSent':
      return 'border-teal-500/30 bg-teal-500/10 text-teal-700 dark:text-teal-300';
    case 'mySent':
      return 'border-teal-500/30 bg-teal-500/10 text-teal-700 dark:text-teal-300';
    case 'combinedMySent':
      return 'border-cyan-500/30 bg-cyan-500/10 text-cyan-700 dark:text-cyan-300';
    default:
      return 'border-indigo-500/30 bg-indigo-500/10 text-indigo-700 dark:text-indigo-300';
  }
}

export function folderKindAccentClass(kind: SearchFolderKind): string {
  switch (kind) {
    case 'inbox':
      return 'border-l-sky-500';
    case 'combined':
      return 'border-l-violet-500';
    case 'sent':
      return 'border-l-emerald-500';
    case 'combinedSent':
      return 'border-l-teal-500';
    case 'mySent':
      return 'border-l-teal-500';
    case 'combinedMySent':
      return 'border-l-cyan-500';
    default:
      return 'border-l-indigo-500';
  }
}

export function resolveFolderKind(kind?: string | null): SearchFolderKind {
  return normalizeSearchFolderKind(kind);
}
